import React from "react";

const StrikeOff = () => {
  return <div>StrikeOff</div>;
};

export default StrikeOff;
